import {createRoot} from 'react-dom/client'
// Axios
import axios from 'axios'
import {Chart, registerables} from 'chart.js'
import {QueryClient, QueryClientProvider} from 'react-query'
import {ReactQueryDevtools} from 'react-query/devtools'
// Apps
import {DesignereyesI18nProvider} from './_designereyes/i18n/Designereyesi18n'
import './_designereyes/assets/fonticon/fonticon.css'
import './_designereyes/assets/keenicons/duotone/style.css'
import './_designereyes/assets/keenicons/outline/style.css'
import './_designereyes/assets/keenicons/solid/style.css'
/**
 * TIP: Replace this style import with rtl styles to enable rtl mode
 *
 * import './_designereyes/assets/css/style.rtl.css'
 **/
import './_designereyes/assets/sass/style.scss'
import './_designereyes/assets/sass/plugins.scss'
import './_designereyes/assets/sass/style.react.scss'

import {AppRoutes} from './app/routing/AppRoutes'
import {AuthProvider, setupAxios} from './app/modules/auth'
/**
 * Creates `axios-mock-adapter` instance for provided `axios` instance, add
 * basic designereyes mocks and returns it.
 *
 * @see https://github.com/ctimmerm/axios-mock-adapter
 */
/**
 * Inject designereyes interceptors for axios.
 *
 * @see https://github.com/axios/axios#interceptors
 */
setupAxios(axios)
Chart.register(...registerables)

const queryClient = new QueryClient()
const container = document.getElementById('root')
if (container) {
  createRoot(container).render(
    <QueryClientProvider client={queryClient}>
      <DesignereyesI18nProvider>
        <AuthProvider>
          <AppRoutes />
        </AuthProvider>
      </DesignereyesI18nProvider>
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  )
}
